export const CERTIFICATION_PROJECT_STATUS = {
  PENDING: "PENDING",
  PENDING_PAYMENT: "PENDING_PAYMENT",
  WIP: "WIP",
  KO: "KO",
  CERTIFIED: "CERTIFIED",
  UNCERTIFIED: "UNCERTIFIED",
  SUSPENDED: "SUSPENDED",
  REVOKED_END_CYCLE: "REVOKED_END_CYCLE",
  REVOKED_MONITORING: "REVOKED_MONITORING",
  REVOKED_MONITORING_CSO: "REVOKED_MONITORING_CSO",
  STOPPED: "STOPPED",
  TRANSFERRED_OUT: "TRANSFERRED_OUT",
};

export const MOTIFS = {
  AUTRE: "autre",
  CONTROLE_DIAGNOSTIC_EN_COURS: "controleDiagnosticEnCours",
  CONTROLE_APRES_ELABORATION_DIAGNOSTIC: "controleApresElaborationDiagnostic",
  CONTROLE_DOCUMENTAIRE: "controleDocumentaire",
  ABSENCE_ACTIVITE: "absenceActivite",
  NON_REALISATION_SURVEILLANCE: "nonRealisationSurveillance",
  PLAINTE: "plainte",
  UTILISATION_FRAUDULEUSE_CERTIFICAT: "utilisationFrauduleuseCertificat",
  NON_RESPECT_CONDITIONS_GENERALES: "nonRespectConditionsGenerales",
  VOLONTAIRE: "volontaire",
  ABSENCE_ATTESTATION_FORMATION: "absenceAttestationFormation",
  ABSENCE_ATTESTATION_ASSURANCE: "absenceAttestationAssurance",
  TRANSFERT: "transfert",
  ARRET_ACTIVITE: "arretActivite",
};

export const CERTIFICATION_PROJECT_CERTIFIED = [
  CERTIFICATION_PROJECT_STATUS.CERTIFIED,
  CERTIFICATION_PROJECT_STATUS.SUSPENDED,
  CERTIFICATION_PROJECT_STATUS.REVOKED_END_CYCLE,
  CERTIFICATION_PROJECT_STATUS.REVOKED_MONITORING,
  CERTIFICATION_PROJECT_STATUS.REVOKED_MONITORING_CSO,
  CERTIFICATION_PROJECT_STATUS.STOPPED,
  CERTIFICATION_PROJECT_STATUS.TRANSFERRED_OUT,
];

export const STATUS_CAN_REGISTER_AGAIN = [
  CERTIFICATION_PROJECT_STATUS.CERTIFIED,
  CERTIFICATION_PROJECT_STATUS.STOPPED,
  CERTIFICATION_PROJECT_STATUS.UNCERTIFIED,
  CERTIFICATION_PROJECT_STATUS.REVOKED_END_CYCLE,
  CERTIFICATION_PROJECT_STATUS.REVOKED_MONITORING,
  CERTIFICATION_PROJECT_STATUS.REVOKED_MONITORING_CSO,
  CERTIFICATION_PROJECT_STATUS.KO,
  CERTIFICATION_PROJECT_STATUS.TRANSFERRED_OUT,
];

export const CERTIFICATION_PROJECT_UNCERTIFIED = [CERTIFICATION_PROJECT_STATUS.UNCERTIFIED];

export const NATURE_DECISION_CERTIFICATION_PROJECT = {
  CERTIFIED: "CERTIFIED",
  UNCERTIFIED: "UNCERTIFIED",
  RECERTIFIED: "RECERTIFIED",
  UNRECERTIFIED: "UNRECERTIFIED",
  NOT_VALIDATED: "NOT_VALIDATED",
  WIP: "WIP",
};

export const NATURE_DECISION_CERTIFICATION_PROJECT_LABEL_MAPPING_STATUS = {
  CERTIFIED: [CERTIFICATION_PROJECT_STATUS.CERTIFIED],
  RECERTIFIED: [CERTIFICATION_PROJECT_STATUS.CERTIFIED],
  UNCERTIFIED: [CERTIFICATION_PROJECT_STATUS.UNCERTIFIED],
  UNRECERTIFIED: [CERTIFICATION_PROJECT_STATUS.UNCERTIFIED],
  NOT_VALIDATED: [CERTIFICATION_PROJECT_STATUS.KO],
  WIP: [
    CERTIFICATION_PROJECT_STATUS.PENDING,
    CERTIFICATION_PROJECT_STATUS.PENDING_PAYMENT,
    CERTIFICATION_PROJECT_STATUS.WIP,
  ],
};
